'use client';
import WalletWrapper from './WalletWrapper';

export default function SignupButton() {
  return (
    <WalletWrapper
      className='min-w-[90px] rounded-lg bg-blue-600 text-white transition-colors duration-200 hover:bg-blue-700'
      text="Sign up"
    />
  );
}
